import { render } from "./ModalSubmissionForm.vue?vue&type=template&id=50f48b99"
import script from "./ModalSubmissionForm.vue?vue&type=script&lang=js"
export * from "./ModalSubmissionForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__